import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import EditCertificateModal from "../Common_profile_details_modals/EditCertificateModal/EditCertificateModal";

function CoursesCard() {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");

  const handleAdd = () => {
    setModalMode("add");
    setShowModal(true);
  };

  const handleEdit = () => {
    setModalMode("edit");
    setShowModal(true);
  };

  const handleOpen = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <Card className="profile-card-pattern profile-pattern-expandable CoursesCard">
        <Card.Body className="profile-card-pattern__body">
          <div
            className="profile-card-pattern__header"
            style={{ marginBottom: 0 }}
          >
            <h2 className="profile-card-pattern__title">
              Courses & certifications
            </h2>
            <Button
              variant="link"
              className="profile-card-pattern__btn-add"
              aria-label="Add courses"
            >
              <span className="summary-card__edit-icon" onClick={handleAdd}>
                ➕
              </span>
            </Button>
          </div>

          <div className="profile-pattern-block__item">
            <div className="profile-pattern-block__item-header">
              <h3 className="profile-pattern-block__main-text">
                Bachelor Of Technology (B.Tech/B.E)
              </h3>

              <Button
                variant="link"
                className="profile-card-pattern__btn-edit"
                aria-label="Edit degree"
              >
                <span className="summary-card__edit-icon" onClick={handleEdit}>
                  ✏️
                </span>
              </Button>
            </div>

            <p className="profile-pattern-block__sub-text">
              Suryodaya College of Engineering & Technology
            </p>

            <p className="profile-pattern-block__meta-text">2022</p>
          </div>
        </Card.Body>
      </Card>

      <EditCertificateModal
        show={showModal}
        handleClose={handleClose}
        mode={modalMode}
      />
    </>
  );
}

export default CoursesCard;
